import React, { useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'
import { templateJson } from './json/templateJson'
import { useMediaQuery } from 'react-responsive'
import * as dayjs from 'dayjs'

const Login = ({ project, ad }) => {
  const today = dayjs().format('YYYY-MM-DD HH:mm:ss')

  const url = window.location.origin
  const info = {
    type: 'panel',
    elements: [
      {
        type: 'html',
        name: 'intro',
        html: `<article class='intro' style='text-align:center'><h4 style='margin-top:50px'>手機下載 EZChoice</h4><h6 style='margin:20px'><a href='https://apps.apple.com/tw/app/ezchoice-%E6%98%93%E6%8F%AA%E7%B6%B2/id1458573198'>Apple Store 下載連結</a></h6><h6 style='margin:20px'><a href='https://play.google.com/store/apps/details?id=com.dataa.newezchoice'>Google Play 商店下載連結</a></h6><h4 style='margin-top:50px'>更多即時好康資訊！<br />立即加入EZChoice Line@好友</h4><h5 style='margin:20px'><a href='https://lin.ee/HWETcqy'>EZChoice LINE@</a></h5></article>`,
      },
    ],
  }
  const projectList = project.map((v, i) => {
    if (v.visible) {
      return {
        type: 'panel',
        elements: [
          {
            type: 'html',
            name: 'intro',
            html: `<article class='intro'><h2 class='intro__heading title'>【${
              v.title
            }】</h2><div class='intro__body home-body'><a href=${
              url + '/' + v.url
            }>點此進入問卷</a></div></article>`,
          },
        ],
      }
    } else {
      return ''
    }
  })
  const adsList = ad.map((v, i) => {
    if (v.endDate > today) {
      return {
        type: 'panel',
        elements: [
          {
            type: 'html',
            name: 'intro',
            html: `<article class='intro'><h2 class='intro__heading title'>【${v.title}】</h2><div class='intro__body home-body'><p style='white-space:pre-wrap;text-align:left;line-height:30px'>${v.description}</p><a href=${v.url}>點此報名</a></div></article>`,
          },
        ],
      }
    } else {
      return ''
    }
  })

  for (let i = 0; i < adsList.length; i++) {
    projectList.push(adsList[i])
  }

  projectList.push(info)

  let myLoginJson = {
    ...templateJson,
    completedHtml: '<h3></h3>',
    completeText: '',
    completedBeforeHtml: '<h3></h3>',
    pages: [
      {
        name: 'page0',
        elements: projectList,
      },
    ],
  }

  const isMobile = useMediaQuery({ query: '(max-width: 576px)' })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const survey = new Model(myLoginJson)
  // useEffect(() => {
  //   console.log('survey2', survey.isMobile)

  //   if (isMobile) {
  //     survey._isMobile = true
  //     console.log('survey3', survey.isMobile)
  //   }
  // }, [survey._isMobile])

  // survey._isMobile = true
  // console.log('survey1', survey.isMobile)
  // console.log('survey', survey._isMobile)
  // console.log('isMobile', isMobile)

  /**
 * import React, { useEffect, useState } from 'react';
import * as Survey from 'survey-react';

const SurveyComponent = () => {
    const [isMobile, setIsMobile] = useState(isMobileDevice());

    useEffect(() => {
        // 監聽窗口大小變化
        const handleResize = () => {
            setIsMobile(isMobileDevice());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const surveyJSON = {
        // ...問卷設置
    };

    // 使用 isMobile 狀態作為條件來渲染不同的組件或樣式
    return (
        <Survey.Survey model={new Survey.Model(surveyJSON)} />
    );
};

export default SurveyComponent;

 */

  return (
    <div className="home">
      <Survey model={survey} />
    </div>
  )
}

export default Login
